import ContentLoader from "react-content-loader";


export function Loader(props) {
    return (
        <ContentLoader
            speed={2}
            width="100%"
            height={800}
            viewBox="0 0 100% 800"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            {...props}
        >
            <rect x="0" y="8" rx="3" ry="3" width="230" height="8" />
            <rect x="0" y="23" rx="0" ry="0" width="100%" height="40" />
            <rect x="0" y="66" rx="0" ry="0" width="100%" height="40" />

            <rect x="0" y="119" rx="3" ry="3" width="230" height="8" />
            <rect x="0" y="134" rx="0" ry="0" width="100%" height="40" />
            <rect x="0" y="177" rx="0" ry="0" width="100%" height="40" />

            <rect x="0" y="230" rx="3" ry="3" width="230" height="8" />
            <rect x="0" y="245" rx="0" ry="0" width="100%" height="40" />
            <rect x="0" y="288" rx="0" ry="0" width="100%" height="40" />

            <rect x="0" y="341" rx="3" ry="3" width="230" height="8" />
            <rect x="0" y="356" rx="0" ry="0" width="100%" height="40" />
            <rect x="0" y="399" rx="0" ry="0" width="100%" height="40" />

            <rect x="0" y="452" rx="3" ry="3" width="230" height="8" />
            <rect x="0" y="467" rx="0" ry="0" width="100%" height="40" />
            <rect x="0" y="510" rx="0" ry="0" width="100%" height="40" />


        </ContentLoader>
    )
}



export function LoaderBol(props) {
    return (
        <ContentLoader
            speed={2}
            width="100%"
            height={400}
            viewBox="0 0 100% 400"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            {...props}
        >
            <rect x="0" y="8" rx="3" ry="3" width="100%" height="38" />
            <rect x="0" y="52" rx="3" ry="3" width="224" height="21" />
            <rect x="0" y="83" rx="3" ry="3" width="100%" height="21" />
            <rect x="0" y="112" rx="3" ry="3" width="100%" height="21" />
            <rect x="0" y="142" rx="3" ry="3" width="100%" height="21" />
            
            <rect x="0" y="177" rx="3" ry="3" width="100%" height="38" />
            <rect x="0" y="221" rx="3" ry="3" width="224" height="21" />
            <rect x="0" y="252" rx="3" ry="3" width="100%" height="21" />
            <rect x="0" y="281" rx="3" ry="3" width="100%" height="21" />
            <rect x="0" y="311" rx="3" ry="3" width="100%" height="21" />
        </ContentLoader>
    )
}


export function LoaderPagos(props) {
    return (
        <ContentLoader
            speed={2}
            width="100%"
            height={200}
            viewBox="0 0 100% 200"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            {...props}
        >
            <rect x="0" y="8" rx="3" ry="3" width="100%" height="38" />
            <rect x="0" y="52" rx="3" ry="3" width="224" height="21" />
            <rect x="0" y="83" rx="3" ry="3" width="100%" height="21" />
            <rect x="0" y="112" rx="3" ry="3" width="100%" height="21" />
            <rect x="0" y="142" rx="3" ry="3" width="100%" height="21" />

        </ContentLoader>
    )
}


export function LoaderProd(props) {
    return (
        <ContentLoader 
        speed={2}
        width={1000}
        height={280}
        viewBox="0 0 1000 280"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        {...props}
      >
        <rect x="0" y="5" rx="0" ry="0" width="280" height="250" /> 
        <rect x="296" y="3" rx="0" ry="0" width="280" height="250" /> 
        <rect x="593" y="2" rx="0" ry="0" width="280" height="250" />
      </ContentLoader>
    )
}






